import { ref, watch, computed } from '@vue/composition-api'
// import store from '@/store'
import store from '@/store/index.js'

// Notification
// import { useToast } from 'vue-toastification/composition'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useMattersList() {
  // Use toast
  // const toast = useToast()

  const refInvoiceListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'unique_id', label: 'Case Ref. Number', sortable: false },
    { key: 'title', sortable: false },
    { key: 'case_status', label: 'Status', sortable: false },
    { key: 'actions' }
  ]
  const perPage = ref(10)
  const totalInvoices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref('Pending')
  // default to Confirmed tab
  // statusFilter values: 'Confirmed' | 'Tentative'
  const courtFilter = ref([])
  const fromDate = ref('')
  const toDate = ref('')
  const orgFilter = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refInvoiceListTable.value
      ? refInvoiceListTable.value.localItems.length
      : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoices.value
    }
  })

  const refetchData = () => {
    refInvoiceListTable.value.refresh()
  }

  watch(
    [
      currentPage,
      perPage,
      searchQuery,
      statusFilter,
      courtFilter,
      orgFilter,
      fromDate,
      toDate
    ],
    () => {
      console.log('Selected ORG: ', orgFilter)
      if (
        (fromDate.value && toDate.value) ||
        (!fromDate.value && !toDate.value)
      ) {
        refetchData()
      }
    }
  )

  const fetchInvoices = (ctx, callback) => {
    console.log('Court Fileter', courtFilter)
    let queryParams = {
      perPage: perPage.value,
      page: currentPage.value
    }

    if (searchQuery.value) {
      queryParams['query'] = searchQuery.value
    }
    if (orgFilter.value) {
      queryParams['filters[organisation]'] = orgFilter.value
    }
    if (statusFilter.value) {
      queryParams['type'] = statusFilter.value.toLowerCase().trim()
    } else {
      queryParams['type'] = 'all'
    }
    console.log(courtFilter)
    if (courtFilter.value && courtFilter.value.length > 0) {
      queryParams['filters[court_id]'] = courtFilter.value
        .map((court) => court.cid)
        .join(',')
    }

    if (fromDate.value && toDate.value) {
      queryParams['range'] = fromDate.value + '-' + toDate.value
    }

    store
      .dispatch('matterStore/fetchMatters', {
        ctx: this,
        queryParams: queryParams
      })
      .then((response) => {
        console.log({ Matters: response })
        // response.data is an array of matters, response.meta contains pagination
        let items = response.data

        // If server returned meta, sync pagination controls with server state
        if (response && response.meta) {
          if (typeof response.meta.page !== 'undefined') {
            currentPage.value = response.meta.page
          }
          if (typeof response.meta.perPage !== 'undefined') {
            perPage.value = response.meta.perPage
          }
          if (typeof response.meta.total !== 'undefined') {
            totalInvoices.value = response.meta.total
          }
        }

        if (
          statusFilter.value &&
          statusFilter.value.toLowerCase().trim() === 'tentative'
        ) {
          items = items.filter((it) => it.matter_status === 'tentative')
        } else if (
          statusFilter.value &&
          statusFilter.value.toLowerCase().trim() === 'confirmed'
        ) {
          items = items.filter((it) => it.matter_status === 'confirmed')
        }

        callback(items)

        // If server didn't send total, fall back to client count
        if (!response || !response.meta || typeof response.meta.total === 'undefined') {
          totalInvoices.value = items.length
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }

  return {
    fetchInvoices,
    tableColumns,
    perPage,
    currentPage,
    totalInvoices,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refInvoiceListTable,
    fromDate,
    toDate,
    statusFilter,
    courtFilter,
    orgFilter,

    refetchData
  }
}
